export const esp = {
  _LOGIN: {
    _EMAIL: "Correo electrónico",
    _PASSWORD: "Contraseña",
    _REMEMBER: "Recuérdame",
    _LOGIN: "INICIAR SESIÓN",
    _SIGNUP: "Registrarse",
    _FORGOTPASSWORD: "¿Olvidaste tu contraseña?",
    _NOACCOUNT: "¿No tienes cuenta?",
    _ERROR_EMAIL: "¡Parece que no estás registrado! Intenta de nuevo.",
    _ERROR_PASSWORD: "Contraseña incorrecta",
    _SUCCESS: "Inicio de sesión exitoso",
  },
  _REGISTER: {
    _REGISTER: "Registrar cuenta",
    _NAME: "Nombre de usuario",
    _EMAIL: "Tu correo electrónico",
    _PASSWORD: "Tu contraseña",
    _CONFIRMPASSWORD: "Confirmar contraseña",
    _WHATSAPP: "WhatsApp",
    _TELEGRAM: "Telegram (opcional)",
    _HAVEACCOUNT: "Ya tengo una cuenta",
    _ERROR_REFERAL: "Código de referido incorrecto",
    _ERROR_EMAIL: "Este correo electrónico ya existe",
    _SUCCESS: "Registro exitoso",
  },
  _SIDEBAR: {
    _PAGES: "Páginas",
    _OPEN: "Abrir barra lateral",
    _DASHBOARD: "Inicio",
    _NETWORK: "Red",
    _FINANCE: "Billetera",
    _PACKAGES: "Planes",
    _SIGNOUT: "Cerrar sesión",
    _LANGUAGE: "Idioma",
    _PROFILE: "Perfil",
    _AUTH: "Autenticador",
  },
  _DASHBOARD: {
    _TITLE: "Balance",
    _TITLE2: "Depósito",
    _TITLE3: "Ganancias Totales",
    _TITLE4: "Ganancias Unilevel",
    _TITLE5: "Bono de Rango Infinito",
    _TITLE6: "Plan",
    _TITLE7: "Bono de Inicio Unilevel",
    _TITLE8: "Bono Binario",
    _TITLE9: "Bono Residual Binario",
    _TITLE10: "Bono Residual de Copy Trading",
    _TOTAL: "Total",
    _TABLE3: "Lista de Paquetes",
    _START: "Iniciar",
    _FINISH: "Finalizar",
    _STATUS: "Estado",
    _STATUS_ACTIVE: "Activo",
    _STATUS_INACTIVE: "Inactivo",
    _CURRENT: "Actual",
    _UPGRADE: "Actualizar",
    _COPYMESSAGE: "Copia exitosa",
    _NOTIFICATION1: "Nuevo Depósito",
    _NOTIFICATION2: "Ganancia Cryptotradex",
    _NOTIFICATION3: "Ganancia Unilevel",
    _NOTIFICATION4: "Rango Infinito",
    _NOTIFICATION5: "Compra Paquete",
    _NOTIFICATION7: "Bono de Referido Directo Recursivo",
    _PREV: "Anterior",
    _NEXT: "Siguiente",
    _TABLE4_A: "Operación",
    _TABLE4_B: "Ganancia",
    _TABLE4_C: "ROI",
    _TABLE4_D: "Fecha",
    _SHARED: "Comparte tu enlace de referido",
    _TITLESHARED: "Enlace de referido",
    _TEXTSHARED:
      "Comparte tu enlace de referido binario y elige la posición donde quieres colocar a tu invitado, o deja que se asigne aleatoriamente.",
    _RANDOM: "Aleatorio",
    _CTFLIX:
      "Fórmate en los modelos de negocio de tendencia y alta rentabilidad con Web3.",
    _SIGNAL:
      "Obtén las mejores señales desde un solo lugar y multiplica tu capital.",
    _COPY:
      "Despreocúpate de estar atento a las llamadas y salidas, copia todas las operativas a 1 clic",
    _CTXII:
      "Multiplica tu capital X12 en automático en alianza con CTX. Contacta a quien te presentó esta oportunidad.",
    _ENTER: "Entrar",
    _INPOSITION: "Etapa de Posicionamiento",
  },
  _FINANCE: {
    _DEPOSIT: "Depósito",
    _QR: "Escanea el siguiente código QR o copia la dirección",
    _NETWORK: "Red",
    _INSTRUCTIONS: "Instrucciones para Enviar SOLANA (SOL)",
    _STEP1: "Asegúrate de que la red seleccionada sea SOLANA.",
    _STEP2:
      "Envía la cantidad de SOLANA a la siguiente dirección de billetera.",
    _COPY: "Copiar",
    _DISCLAIMER:
      "Descargo de responsabilidad: No nos responsabilizamos por transacciones realizadas fuera de la red SOLANA o por el envío de criptomonedas que no sean SOLANA. Cualquier pérdida de fondos debido a estos errores será responsabilidad exclusiva del remitente.",
    _TABLE1: "Historial de Depósitos",
    _TABLE1_A: "Orden",
    _TABLE1_B: "Cantidad",
    _TABLE1_C: "Fecha",
    _TABLE1_D: "Estado",
    _SUCCESS: "El paquete se agregó exitosamente",
    _COPYMESSAGE: "Dirección de billetera copiada exitosamente",
  },
  _PACKAGES: {
    _ATTENTION:
      "Atención: Tienes una cuenta corporativa. Al comprar un paquete, reiniciarás la cuenta y todos sus beneficios.",
    _PACKAGES: "Selecciona el mejor plan para ti",
    _SUBTITLE: "Tienes 8 opciones",
    _BALANCE: "Depósito de balance",
    _PACKAGE: "Paquete ",
    _PACKAGE_1: "Ganarás hasta el nivel ",
    _PACKAGE_2: "Gana hasta",
    _PACKAGE_3: "ROI semanal",
    _BUTTON1: "Lleno",
    _BUTTON2: "Comprar",
    _CALCULATE: "Calcular plan",
    _RECHARGE: "No tienes suficiente dinero, recarga tu billetera",
    _PACKAGEMESSAGE: "Debes comprar un paquete superior",
    _SUCCESS: "El paquete se agregó exitosamente",
    _UPDATE: "Precio de actualización del paquete",
    _BASIC: "Básico",
    _INTERMEDIATE: "Básico + Intermedio",
    _ADVANCED: "Básico + Intermedio + Avanzado",
    _COMPLETED: "Completado",
    _SIGNALS: "Señales CTX",
    _COPY: "CopyTrading CTX",
  },
  _NETWORK: {
    _TODAY: "Hoy",
    _AVAILABLE: "Disponible",
    _WITHDRAW: "Total Retirado",
    _SEARCHLABEL: "Búsqueda por correo electrónico",
    _SEARCH: "Buscar",
    _NETWORK: "Red",
    _DIRECTS: "Referidos directos",
    _SUCCESS: "Búsqueda exitosa",
    _ERROR: "No forma parte de tu árbol.",
    _LEVEL: "Nivel",
    _USERS: "Usuarios",
    _AMOUNT: "Monto",
    _USERNAME: "Nombre de usuario",
    _EMAIL: "Correo electrónico",
    _WHATSAPP: "WhatsApp",
    _PACKAGE: "Paquete",
    _LEFT: "Izquierda",
    _RIGHT: "Derecha",
    _TOTALLEFT: "Total acumulado izquierda",
    _TOTALRIGHT: "Total acumulado derecha",
    _BINARYTEXT:
      "Para colocar tu referido en el árbol binario, presiona y mantén el botón correspondiente (izquierda o derecha). Recuerda que esta acción solo puede realizarse una vez, por lo que te recomendamos revisar cuidadosamente tu selección antes de confirmar.",
    _BINARYSUCCESS: "Transacción completada exitosamente",
    _BINARYLOADING: "Cargando...",
    _SEARCHFORUSERNAME: "Buscar por nombre de usuario",
    _TANK: "Tanque de referidos directos",
  },
  _PROFILE: {
    _TITLE: "Perfil",
    _NAME: "Tu nombre",
    _EMAIL: "Tu correo electrónico",
    _WHATSAPP: "WhatsApp",
    _CURRENTPASSWORD: "Contraseña actual",
    _PASSWORD: "Nueva contraseña",
    _CONFIRMPASSWORD: "Confirmar nueva contraseña",
    _WALLET: "Dirección de retiro",
    _ACTION: "Editar",
    _TIPS: "Consejos",
    _TIPS_1: "El nombre debe ser legible y no superar los 20 caracteres.",
    _TIPS_2:
      "La contraseña debe incluir números, letras y símbolos; cuanto más compleja, mejor.",
    _TIPS_3:
      "El correo electrónico no puede ser cambiado. Si necesitas realizar un cambio, por favor escribe a soporte.",
    _TIPS_4:
      "La dirección de retiro solo puede ser modificada con un autenticador de 2 factores, que debe estar habilitado previamente.",
    _ERROR_PASSWORD: "Error en la contraseña anterior",
    _SUCCESS: "Perfil actualizado exitosamente",
    _MIN: "Retiro mínimo",
    _UPDATE: "Actualizar perfil",
  },
  _RECOVERPASSWORD: {
    _RECOVERPASSWORD: "¿Olvidaste tu contraseña?",
    _EMAIL: "Tu correo electrónico",
    _BUTTON: "Enviar correo",
    _MESSAGE: "Tu contraseña fue enviada a tu correo",
    _ERROR_EMAIL: "Este correo no está registrado",
  },
  _GLOBALV: {
    _TITLE: "GV",
    _CURRENT: "Rango actual",
    _NEXT: "Próximo rango",
    _SILVER: "Plata",
    _GOLD: "Oro",
    _RUBY: "Rubí",
    _EMERALD: "Esmeralda",
    _DIAMOND: "Diamante",
    _DIAMONDB: "Diamante Azul",
    _DIAMONDBB: "Diamante Negro",
    _NONE: "Ninguno",
  },
  _AUTH: {
    _TITLEDEFAULT: "Cambiar dirección de retiro",
    _TITLE: "Paso 1",
    _TITLE2: "Paso 2",
    _TITLE3: "Paso 3",
    _STEP1: "Descarga e instala el autenticador en tu dispositivo",
    _STEP2: "Escanea el código para guardarlo",
    _FORMEMAIL: "Verificación de correo electrónico",
    _FORMHELPEMAIL:
      "Introduce el código de verificación de 6 dígitos enviado a",
    _FORMHELPAUTH:
      "Introduce el código de 6 dígitos generado por la aplicación Authenticator",
    _FORM1: "Pin por Authenticator",
    _FORM2: "Dirección de retiro",
    _FORMMIN: "La dirección de retiro debe tener 34 caracteres",
    _FORMCODESEND: "Código enviado",
    _VERIFF: "Veriff",
    _ACTION: "Verificar y guardar",
    _ERROR: "Error, intenta nuevamente.",
    _SUCCESS: "Cambio exitoso",
    _RETRYOTP: "Error al enviar el código, intenta nuevamente.",
    _SENDOTP: "Código enviado exitosamente",
    _SUCCESSOTP: "OTP verificado satisfactoriamente",
    _SUCCESSAUTH2F: "Autenticación 2FA verificada satisfactoriamente",
    _ERRORCODE: "Código inválido, intenta de nuevo",
  },
  _COUNTDOWN: {
    _TITLE: "Próximo corte:",
    _DAYS: "Días",
    _HOURS: "Horas",
    _MINUTES: "Minutos",
    _SECONDS: "Segundos",
  },
  _WITHDRAWAL: {
    _TITLE: "Transacciones de Retiro",
    _ERRORPROCESS: "Ya tienes otro retiro en proceso, espera unos minutos",
    _ERRORWALLET: "Primero debes configurar tu billetera de retiro Solana",
    _ERRORBALANCE: "El balance negativo se reinicia nuevamente.",
    _ERROROTHER: "Error al realizar el retiro, por favor intenta nuevamente.",
    _SUCCESS: "Retiro exitoso. Llegará a tu billetera en minutos.",
  },
  _SYSTEM: {
    _SYSTEM: "Sistema",
    _GLOBAL: "Global",
    _INVESTMENT: "Retirar inversión",
    _INVESTMENTTEXT:
      "Recuerda que tendrás una penalización del 35% de tu inversión",
    _ACCELERATE: "Acelerar",
    _REPORT: "Informe de inversión Cryptotradex",
    _PARNERT: "Información del patrocinador",
  },
  _WITHDRAWINVESTMENT: {
    _TITLE: "Retirar inversión",
    _MESSAGE:
      "Retirar tu capital ahora implica una tarifa operativa del 35% de tu inversión - ganancias acumuladas, y se procesará dentro de 24 horas. Si haces esto, detendrás su potencial de crecimiento inmediato. ¡Decide con visión a largo plazo!",
    _BUTTON: "Retirar",
    _BUTTONWAIT: "Retiro en proceso",
  },
  _SIGNAL: {
    _NEWS: "Nuevo",
    _SIGNALS: "Señales",
    _CHAT: "Chat exclusivo",
    _OPEN: "Abierto",
    _CLOSED: "Cerrado",
    _PRICEENTRY: "Precio de entrada",
    _PRICEEND: "Precio de cierre",
    _INITIAL: "Precio inicial",
    _MAXIMUN: "Precio maximo ATH",
    _DATEATH: "Fecha ATH",
    _MKCAP: "Mkt Cap",
  },
  _ACADEMY: {
    _NEWS: "Nuevo",
    _TITLE: "Academia",
    _WHATIS: "¿Qué es Cryptotradex Academy?",
    _DESCRIPTION:
      "Aprende sobre criptomonedas, billeteras, memes y Web3 con nuestra plataforma en línea diseñada para todos los niveles.",
    _ACTION1: "Ir a la Academia",
    _DISABLED: "Se requiere un depósito mínimo de 500 USD",
    _TITLANDING: "Conviértete en un experto en Cryptomemes",
    _DESCRIPTIONLANDING:
      "Accede a tutoriales exclusivos del paquete BRETT y aprende a dominar el mundo de los MEMECOINS.",
    _ACTIONLANDING: "¡Regístrate ahora y comienza a aprender!",
    _WHATCOURSES: "¿Qué cursos recibirás?",
    _RECOMMENDS: "Videos recomendados",
  },
  _FREE: {
    _FREE: "Gratis",
    _FREEFOR: "GRATIS POR UN LARGO TIEMPO",
    _SIGNALS: "Ir a Señales",
    _LINK: "Enlace de la Comunidad",
    _TITLE:
      "Únete a nuestra comunidad de WhatsApp para obtener información inmediata y en tiempo real",
    _DISCLAIMER: "Descargo de responsabilidad",
    _CHANNEL: "Ir al canal",
    _TEXTDISCLAIMER:
      "Estas señales tienen un período de ejecución, en el momento en que las publicamos en nuestro grupo de señales es cuando logramos la ganancia demostrada.",
    _LEGEND: "Leyenda",
    _NAME: "Nombre del token",
    _URL: "Enlace a DexScrenner",
    _START: "Hora de inicio",
    _END: "Hora de fin",
    _PROFIT: "Ganancia",
    _VER: "Ir",
  },
  _CTFLIX: {
    _BASIC: "Basico",
    _INTERMEDIATE: "Intermedio",
    _ADVANCED: "Avanzado",
    _MODULE0: "Modulo Inicial",
    _MODULE1: "Modulo 1 Seguridad en cryptos",
    _MODULE2: "Modulo 2 Coinbase",
    _MODULE3: "Modulo 3 Bybit",
    _MODULE4: "Modulo 4 Binance",
    _MODULE5: "Modulo 5 Exchanges",
    _MODULE6: "Modulo 6 Herramientas Basicas",
    _MODULE7: "Modulo 7 Rabby Wallet",
    _MODULE8: "Modulo 8 Billetera Phantom",
    _MODULE9: "Modulo 9 Trezor",
    _MODULE10: "Modulo 10 Ledger",
    _MODULE11: "Modulo 11 Herramientas Onchain",
    _MODULE12: "Modulo 12 Analisis OnChain",
    _MODULE13: "Modulo 13 GMGN",
    _MODULE14: "Modulo 14 Dexscreener Avanzado",
    _MODULE15: "Modulo 15 Bot Bull x NEO",
    _ALLLANGUAGE: "Todos los idiomas",
    _ALLTYPES: "Todos los tipos",
    _ALLLMODULES: "Todos los Modulos",
    _REQUIREDBASIC:
      "¡Actualiza tu paquete y accede a módulos exclusivos como: Seguridad en Crypto, Coinbase, Bybit, Binance, y más de 54 videos educativos!",
    _REQUIREDINTERMEDIATE:
      " ¡No dejes que te falten módulos clave como: Exchanges, Herramientas Básicas, y el uso de Wallets como Rabby Wallet, Phantom, Trezor y Ledger! Actualiza tu paquete y mantén acceso a todo el contenido.",
    _REQUIREDADVANCED:
      "¡No pierdas acceso a herramientas avanzadas como: Análisis Onchain, GMGN, DexScreener y aprende a usar el Bot Bull Neo! Actualiza tu paquete para explorar todo el potencial de estas plataformas.",
  },
  _COPY: {
    _TITLE: "Mi billetera de Copia Trading",
    _MIN: "Minimo de deposito 300 USD",
    _BALANCE: "Balance",
    _TYPE: "Tipo",
    _CONSERVE: "Conservador",
    _CONSERVEDESCRIPTION: "Bajo riesgo, estabilidad y preservación de capital.",
    _MODERADE: "Moderado",
    _MODERADEDESCRIPTION: "Equilibrio entre riesgo y crecimiento.",
    _ADVANCED: "Arriesgado",
    _ADVANCEDDESCRIPTION:
      "Alto riesgo, altos rendimientos potenciales, alta volatibilidad.",
    _SLIPPAGE: "Desplazamiento",
    _SUPPLY: "Monto a operar",
    _TIME: "Tiempo",
    _STATISTICS: "Estadisticas",
    _DISCLAIMER:
      "Para activar el sistema de copy trading, es necesario realizar un depósito inicial con un monto mínimo de <strong class='text-red-300'>300 USD</strong>. Una vez realizado este paso, el sistema pasará por una etapa de configuración que puede tardar entre 24 a 72 horas hábiles. <br/> <br/> Luego de este proceso, el sistema comenzará a operar en tiempo real, replicando las estrategias de nuestro equipo de traders.  <br/> <br/> Cabe destacar que no estamos obligados a realizar operaciones todos los días. Solo ejecutamos operaciones cuando el mercado presenta condiciones favorables, evitando riesgos innecesarios. <br/> <br/> Este sistema no garantiza rendimientos constantes. Los usuarios aceptan que las ganancias y pérdidas forman parte natural del comportamiento del mercado, el cual es libre y no está manipulado. En caso de pérdidas, no se aceptarán reclamos. <br/> <br/> Sin embargo, estamos profundamente orgullosos de nuestros conocimientos y experiencia, y trabajamos con responsabilidad en cada decisión tomada. <br/> <br/> Finalmente, todo el proceso de copy trading incluye una etapa de configuración y verificación manual, en la cual se validan los datos del usuario y la información del sistema antes de su activación.",
    _ACTION: "Acciones",
    _PORTFOLIO: "Portafolio",
    _CAPITAL: "Retirar Capital",
    _EARNINGS: "Retirar Ganancias",
    _CONNECTION: "Conexión",
  },
  _NOTICE: {
    _NOTICE: "Aviso Estelar",
    _CRYPTOCARD: "CryptoCard está en camino",
    _DESCRIPTION: "Nuestra tarjeta, prepárate para una experiencia total.",
    _NEW: "¿Nuevo miembro?",
    _DISCOVERY: "Descubre todo lo que tenemos para",
    _YOU: "ti",
    _MYBUSINESS: "Mi negocio",
    _MYPRODUCTS: "Mis productos",
  },
  _STATISTICS: {
    _FROM: "Desde",
    _UNTIL: "Hasta",
    _NUMBERSOPERATIONS: "Cantidad de transacciones",
  },
};
